import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  newUnitButton: {
    id: 'course-authoring.course-outline.subsection.button.new-unit',
    defaultMessage: 'New unit',
  },
  pasteButton: {
    id: 'course-authoring.course-outline.subsection.button.new-unit',
    defaultMessage: 'Paste unit',
  },
});

export default messages;
